import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import { ProsAndCons } from '@repo/ui-v2/ProsAndCons';

export type SMBProsAndConsTableProps = StructuredContentDocument<{
  pros?: string[];
  cons?: string[];
}>;

export function SMBProsAndConsTable({ props }: SMBProsAndConsTableProps) {
  return (
    <div className={css({ paddingTop: '4', paddingRight: '4', paddingBottom: '4', paddingLeft: '4' })}>
      <ProsAndCons prosList={props.pros} consList={props.cons} />
    </div>
  );
}
